module.exports = __webpack_public_path__ + "Tinebase/js/ace-ext-error_marker-FAT.js";